import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { fetchCount } from "./appAPI";

export interface AppState {
  showSignIn: boolean;
  showSignUp: boolean;
  showBooking: boolean;
  developers: TDataTable;
  pickedDevelopers: string[];
  status: "idle" | "loading" | "failed" | "finished";
}

const initialState: AppState = {
  showSignIn: false,
  showSignUp: false,
  showBooking: false,
  developers: [],
  pickedDevelopers: [],
  status: "idle",
};

export const fetchDataFromServer = createAsyncThunk(
  "counter/fetchCount",
  async () => {
    const response = await fetchCount();
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const appSlice = createSlice({
  name: "App",
  initialState,
  reducers: {
    setSignIn: (state, action: PayloadAction<boolean>) => {
      state.showSignIn = action.payload;
    },

    setSignUp: (state, action: PayloadAction<boolean>) => {
      state.showSignUp = action.payload;
    },

    showSignUp: (state) => {
      state.showSignUp = true;
    },

    setBooking: (state, action: PayloadAction<boolean>) => {
      state.showBooking = action.payload;
    },

    setSelectedDevelopers: (state, action: PayloadAction<string[]>) => {
      state.pickedDevelopers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataFromServer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDataFromServer.fulfilled, (state, action) => {
        state.status = "finished";
        state.developers = action.payload;
      })
      .addCase(fetchDataFromServer.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const {
  setSignIn,
  setSignUp,
  showSignUp,
  setBooking,
  setSelectedDevelopers,
} = appSlice.actions;

export const selectAppSignIn = (state: RootState) => state.app.showSignIn;
export const selectAppSignUp = (state: RootState) => state.app.showSignUp;
export const selectAppBooking = (state: RootState) => state.app.showBooking;
export const selectPickedDevelopers = (state: RootState) =>
  state.app.pickedDevelopers;

export const selectDevelopers = (state: RootState) => state.app.developers;
export const selectStatus = (state: RootState) => state.app.status;

export default appSlice.reducer;
